import { render, staticRenderFns } from "./QutaParameter.vue?vue&type=template&id=5c61fc49&scoped=true&"
import script from "./QutaParameter.vue?vue&type=script&lang=js&"
export * from "./QutaParameter.vue?vue&type=script&lang=js&"
import style0 from "./QutaParameter.vue?vue&type=style&index=0&id=5c61fc49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c61fc49",
  null
  
)

export default component.exports